import { render } from "./SkeletonBanner.vue?vue&type=template&id=cb1f55e0"
import script from "./SkeletonBanner.vue?vue&type=script&lang=js"
export * from "./SkeletonBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__